import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { connect } from 'react-redux';
import { METHODS } from '../constants/checkoutConstants';

// components
import CheckoutCreditCardView from './creditCard/CheckoutCreditCardView';
import CheckoutPayPalView from './payPal/CheckoutPayPalView';
import CheckoutWireTransferView from './wireTransfer/CheckoutWireTransferView';
import CheckoutCheckView from './check/CheckoutCheckView';
import CheckoutApplePayView from './applePay/CheckoutApplePayView';
import CheckoutBankAccountView from './bankAccount/CheckoutBankAccountView';
import { CheckoutKlarnaView } from './klarna/CheckoutKlarnaView';

function CheckoutPaymentView({ buyer, paymentMethodApiType, paymentMethodToken }) {
    const walletPaymentMethods = buyer?.wallet?.paymentMethods || [];
    const walletPaymentMethod = walletPaymentMethods.find(
        ({ paymentMethod }) => paymentMethod?.token === paymentMethodToken
    );
    const paymentMethod = walletPaymentMethod?.paymentMethod;
    const nonWalletPaymentMethods = [METHODS.METHOD_KLARNA];

    if (
        paymentMethodToken &&
        !paymentMethod &&
        !nonWalletPaymentMethods.includes(paymentMethodApiType)
    ) {
        return null;
    }

    switch (paymentMethodApiType) {
        case METHODS.METHOD_CREDIT_CARD:
            return (
                <CheckoutCreditCardView
                    creditCard={paymentMethod}
                    hideName
                    hideExpiration
                    transaction={null}
                />
            );
        case METHODS.METHOD_PAYPAL_ACCOUNT:
            return <CheckoutPayPalView payPalAccount={paymentMethod || null} hideName />;
        case METHODS.METHOD_WIRE_TRANSFER:
        case METHODS.METHOD_ON_PLATFORM_WIRE_TRANSFER:
            return <CheckoutWireTransferView />;
        case METHODS.METHOD_CHECK:
            return <CheckoutCheckView />;
        case METHODS.METHOD_APPLE_PAY:
            return <CheckoutApplePayView />;
        case METHODS.METHOD_ACH:
            return <CheckoutBankAccountView bankAccount={paymentMethod} />;
        case METHODS.METHOD_KLARNA:
            return <CheckoutKlarnaView />;
        default:
            return null;
    }
}

CheckoutPaymentView.propTypes = {
    buyer: PropTypes.object.isRequired,
    paymentMethodApiType: PropTypes.oneOf(Object.values(METHODS)),
    paymentMethodToken: PropTypes.string,
};

const ConnectedCheckoutPaymentView = connect(({ transaction }) => ({
    paymentMethodApiType: transaction.paymentMethodApiType,
    paymentMethodToken: transaction.paymentMethodToken,
}))(CheckoutPaymentView);

export default createFragmentContainer(ConnectedCheckoutPaymentView, {
    buyer: graphql`
        fragment CheckoutPaymentView_buyer on User {
            wallet {
                paymentMethods {
                    paymentMethod {
                        __typename
                        ... on CreditCard {
                            ...CheckoutCreditCardView_creditCard
                            token
                        }
                        ... on PayPalAccount {
                            ...CheckoutPayPalView_payPalAccount
                            token
                        }
                        ... on ACH {
                            ...CheckoutBankAccountView_bankAccount
                            token
                        }
                    }
                }
            }
        }
    `,
});
